// extracted by mini-css-extract-plugin
module.exports = {"smallField":"LateFeeSection_smallField__34ZRv","typeField":"LateFeeSection_typeField__KdEfj","intervalField":"LateFeeSection_intervalField__FkQpB"};